<% availableRules.forEach(function(rule) { %>
  <% selectedOption = visit_type_rule_selections.find(function(ruleSelection) { return ruleSelection.id == rule.id }) || {} %>
  <div class="field appointment-booking-wizard-visit-step-visit-type-rules-visit-type-rule-field">
    <label class="field-label"><%- rule.name %></label>
    <div class="radio-buttons">
      <% rule.options.forEach(function(option) { %>
        <label class="radio-button" role="button" tabindex="0">
          <input data-appointment-booking-wizard-behaviour="field-input" type="radio" name="visit_type_rule_selections[<%= rule.id %>][option_id]" value="<%= option.id %>" <% if (selectedOption.option_id == option.id) { %>checked<% } %>>
          <div class="select-indicator"></div>
          <span class="radio-label"><%- option.name %></span>
        </label>
      <% }) %>
    </div>

    <% rule.options.forEach(function(option) { %>
      <% if (option.message && selectedOption.option_id == option.id) { %>
        <div class="appointment-booking-wizard-callout borderless">
          <div class="message message-warning">
            <% if (option.message_title) { %>
              <h4 class="message__title"><%- option.message_title %></h4>
            <% } %>
            <div class="message__content">
              <%= option.message %>
            </div>
          </div>
        </div>
      <% } %>
    <% }) %>
  </div>
<% }) %>
